import { render, staticRenderFns } from "./LicenseChangePreview.vue?vue&type=template&id=b169a49e"
import script from "./LicenseChangePreview.vue?vue&type=script&lang=js"
export * from "./LicenseChangePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports